import { makeUseAxios } from 'axios-hooks';
import axios from 'axios';
import { env } from 'Shared/constants/env';
import { makeApiHooks } from './makeHooks';

const axiosInstance = axios.create({
  baseURL: `${env.reznorHostname}/bindapi`,
});

const useAxios = makeUseAxios({
  axios: axiosInstance,
});

export const { useLazyApi: useLazyBindApi } = makeApiHooks(useAxios);
